import { render, staticRenderFns } from "./ScopeLiteratureLauncher.vue?vue&type=template&id=c5d34006&scoped=true"
import script from "./ScopeLiteratureLauncher.vue?vue&type=script&lang=js"
export * from "./ScopeLiteratureLauncher.vue?vue&type=script&lang=js"
import style0 from "./ScopeLiteratureLauncher.vue?vue&type=style&index=0&id=c5d34006&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d34006",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5d34006')) {
      api.createRecord('c5d34006', component.options)
    } else {
      api.reload('c5d34006', component.options)
    }
    module.hot.accept("./ScopeLiteratureLauncher.vue?vue&type=template&id=c5d34006&scoped=true", function () {
      api.rerender('c5d34006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealScope/ScopeLiteratureLauncher.vue"
export default component.exports